import React from 'react';
import QuoteForm from '../components/QuoteForm';

/**
 * Two-column hero layout: left = intro copy, right = sticky QuoteForm.
 */
const PageHero = ({
  eyebrow,
  headline,
  headlineAccent,
  description,
  category = 'general',
  subtype = '',
  service = 'General',
  formTitle = 'Get a free quote',
  formSubtitle = 'A specialist will reach out within 24 hours.',
  formTestId = 'quote-form',
  ctaLabel = 'Get Free Quote',
}) => (
  <section className="bg-[#FAF2E8] pt-14 pb-14">
    <div className="max-w-7xl mx-auto px-5 lg:px-10 grid lg:grid-cols-[1.35fr_1fr] gap-10 items-start">
      <div>
        <div className="text-xs uppercase tracking-wider text-[#F39200] font-semibold mb-3">{eyebrow}</div>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-neutral-900 leading-[1.05] max-w-3xl">
          {headline}{' '}
          {headlineAccent && (
            <span className="relative inline-block text-[#F39200]">
              {headlineAccent}
              <svg className="absolute -bottom-2 left-0 w-full" height="10" viewBox="0 0 400 10" fill="none">
                <path d="M2 7 C 100 1, 240 1, 398 6" stroke="#F39200" strokeWidth="2" strokeLinecap="round" fill="none" />
              </svg>
            </span>
          )}
        </h1>
        <p className="mt-5 text-[15px] md:text-base text-neutral-600 max-w-2xl leading-relaxed">
          {description}
        </p>
      </div>
      <div>
        <QuoteForm
          category={category}
          subtype={subtype}
          service={service}
          title={formTitle}
          subtitle={formSubtitle}
          ctaLabel={ctaLabel}
          testId={formTestId}
        />
      </div>
    </div>
  </section>
);

export default PageHero;
